<template>
  <NavMenu />
  <router-view :key="$route.path" />
  <Footer
    v-if="
      $route.path != '/onze-bevindingen/nieuwsbrief' &&
      $route.path != '/nieuwsbericht' &&
      $route.path != '/regeling'
    "
  />
</template>

<script>
import { onMounted } from "vue";
import NavMenu from "./components/NavMenu.vue";
import Footer from "./views/Footer.vue";
export default {
  name: "App",
  components: {
    NavMenu,
    Footer,
  },
  setup() {
    onMounted(() => {
      document.documentElement.lang = "nl";
    });
    return {};
  },
};
</script>
